import { Component, computed, input, TemplateRef } from "@angular/core";

@Component({
  selector: "app-validation-report-summary",
  standalone: false,
  templateUrl: "./validation-report-summary.component.html",
  styleUrl: "./validation-report-summary.component.scss",
})
export class ValidationReportSummaryComponent {
  reportSummaryInput = input.required<any>();

  get reportSummary() {
    return this.reportSummaryInput();
  }

  customRowTpl = input<Record<string, TemplateRef<any>> | null>(null);

  get templates() {
    return this.customRowTpl();
  }

  customContentTpl = input<Record<string, TemplateRef<any>> | null>(null);

  get customContent() {
    if (!this.customContentTpl) {
      return null;
    }
    return this.customContentTpl();
  }

  rowConfig = input.required<any[]>();

  get rows() {
    return this.rowConfig();
  }

  templateKeys = computed(() => {
    if (!this.customRowTpl()) return [];
    return Object.keys(this.customRowTpl() as any);
  });

  constructor() {}
}
